<div class="d-flex gap-10 ai-center f-s-18 m-t-30 m-b-20 f-w-600 text-blackTitle">
    <i-tabler name="text-size" class="icon-25 stroke-1 text-title-category" />
    Tamanho da fonte
</div>
<div class="d-flex ai-center gap-20">
    <button type="button" class="btn flat-button" (click)="setFontSize('a-')"
        [disabled]="fontSize === 89.75">A-</button>
    <button type="button" class="btn stroked-button" (click)="setFontSize('a')">A</button>
    <button type="button" class="btn flat-button" (click)="setFontSize('a+')"
        [disabled]="fontSize === 121.75">A+</button>
</div>